/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */



 jQuery(function($){
   $.datepicker.regional.fr = {
     closeText: 'Fermer',
     prevText: '&#x3c;Préc',
     nextText: 'Suiv&#x3e;',
     currentText: 'Aujourd\'hui',
     monthNames: ['Janvier','Fevrier','Mars','Avril','Mai','Juin',
     'Juillet','Aout','Septembre','Octobre','Novembre','Decembre'],
     monthNamesShort: ['Jan','Fev','Mar','Avr','Mai','Jun',
     'Jul','Aou','Sep','Oct','Nov','Dec'],
     dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
     dayNamesShort: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
     dayNamesMin: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
     weekHeader: 'Sm',
     dateFormat: 'dd-mm-yy',
     showButtonPanel: true,
     firstDay: 1
     };
   $.datepicker.setDefaults($.datepicker.regional.fr);
 });



(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // // /********* STICKY MENU **********/
        if($('body').hasClass('home')){
          var stickyNavTop = 100;
        }
        else {
          if($('.post_content').length > 0){
            var stickyNavTop = $('.post_content').offset().top-200;
          }
        }

        var stickyNav = function(){
        var scrollTop = $(window).scrollTop();

        if (scrollTop > stickyNavTop) {
            $('#header').addClass('sticky');
        } else {
            $('#header').removeClass('sticky');
        }
        };

        stickyNav();

        $(window).scroll(function() {
            stickyNav();
        });

        /**
         * NEWSLETTTER
         */
         if($('.newsletter-form').size() > 0){

             $('.newsletter-form .btn-submit').click(function(e) {
                 e.preventDefault();
                 var button = $(this);
                 var form = $('.newsletter-form');
                 $('.newsletter .error').html('');
                 $('.newsletter .error').hide();

                 button.hide();
                 $('.newsletter .loader').show();
                 $.ajax({
                     method: "POST",
                     url: form.attr('action'),
                     data: form.serialize()
                 })
                 .success(function( response ) {
                     $('.newsletter .loader').hide();
                     button.show();
                     if(response === 'ok'){
                         $('.newsletter .error').html(response);
                     }
                     else{
                         $('.newsletter .error').html(response);
                     }
                     $('.newsletter .error').fadeIn();
                 });
             });
         }

        /**
         * MINI-CAROUSEL
         */
        if($('.minicarousel').size() > 0){

            $('.minicarousel').each(function(){
                var owlc = $(this);
                owlc.slick({
                    slidesToShow: owlc.data('items'),
                    slidesToScroll: 1,
                    arrows: owlc.data('navigation'),
                    autoplay: owlc.data('autoplay'),
                    autoplaySpeed: owlc.data('speed'),
                    dots: owlc.data('pagination'),
                    fade: false,
                    draggable:false,
                    focusOnSelect:false,
                    swipe:false,
                    adaptiveHeight: true,
                    responsive: [
                      {
                        breakpoint: 768,
                        settings: {
                          slidesToShow: owlc.data('tablet')
                        }
                      },
                      {
                        breakpoint: 767,
                        settings: {
                          slidesToShow: owlc.data('mobile')
                        }
                      }
                    ]
                });
            });

            $('.minicarousel').magnificPopup({
              delegate: 'a',
              type: 'image',
              tLoading: 'Chargement...',
              mainClass: 'mfp-img-mobile',
              gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
              },
              image: {
                tError: '<a href="%url%">L\'image #%curr%</a> n\'a pas pu être chargée.',
                /*titleSrc: function(item) {
                  return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
                }*/
              }
            });
          }

          $(document).bind('gform_confirmation_loaded', function(event, formId){
            if(formId === 4 || formId === 2) {
              localStorage.setItem('have_already_form', true);
              $('.slideshow-protect-form').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: true,
                  dots: true,
                  fade: false,
                  draggable:false,
                  focusOnSelect:false,
                  swipe:false,
                  adaptiveHeight: true,
              });
              $('.slideshow-protect-form').on('contextmenu', '.slide', function(e){
                return false;
              });
            }
          });

          if($('.slideshow-protect, .slideshow-protect-form').size() > 0){
            $('.slideshow-protect, .slideshow-protect-form').each(function(){
                var slshow = $(this);
                slshow.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    fade: false,
                    draggable:false,
                    focusOnSelect:false,
                    swipe:false,
                    adaptiveHeight: true,
                });
            });
            $('.slideshow-protect, .slideshow-protect-form').on('contextmenu', '.slide', function(e){
              return false;
            });
          }

          if($('.popup-with-form').size() > 0){
              $('.popup-with-form').magnificPopup({
                  callbacks: {
                      beforeOpen: function() {
                        $('#input_2_3').val(this.st.el.data('pdf'));
                      }
                  }
              });
          }

          function sendTimeTrackData(page, time, startData){
            $.ajax({
              type: 'POST',
              async: false,
              url: 'https://www.conseilorga.com/wp-admin/admin-ajax.php',
              data: {
                action: 'collect_user_time',
                page: page,
                time: time,
                startData: startData,
              }
            });
          }

          function printMysqlFormat(d) {
            var day = d.getDate() + "";
            var month = (d.getMonth() + 1) + "";
            var year = d.getFullYear() + "";
            var hour = d.getHours() + "";
            var minutes = d.getMinutes() + "";
            var seconds = d.getSeconds() + "";

            day = day.length == 1 ? "0" + day : day;
            month = month.length == 1 ? "0" + month : month;
            hour = hour.length == 1 ? "0" + hour : hour;
            minutes = minutes.length == 1 ? "0" + minutes : minutes;
            seconds = seconds.length == 1 ? "0" + seconds : seconds;

            return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
          }

          if($('body.page-id-684, body.page-id-816, body:not(.page):not(.blog):not(.single)').size()>0){
            TimeMe.initialize({
          		currentPageName: "timetrack-page", // current page
          		idleTimeoutInSeconds: 30 // seconds
          	});
            var dNow = new Date();
            var startData = printMysqlFormat(dNow);
            var page = location.href;
            setInterval(function(){
              var time = TimeMe.getTimeOnPageInSeconds("timetrack-page");
              sendTimeTrackData(page, time, startData);
            }, 60000);

            window.addEventListener("beforeunload", function (event) {
                var page = location.href;
                var time = TimeMe.getTimeOnPageInSeconds("timetrack-page");
                sendTimeTrackData(page, time, startData);
            })
          }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        if($('.home #slider').size()>0){
          $('.home #slider .home-carousel').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots:false,
              autoplay: true,
              autoplaySpeed: 6000,
              infinite: true,
              pauseOnHover: false
          });
        }

        if($('.home .subpages').size()>0){
          $('.home .subpages .list').slick({
              slidesToShow: 4,
              slidesToScroll: 4,
              arrows: false,
              dots:false,
              autoplay: true,
              autoplaySpeed: 3000,
              infinite: true,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:true,
                  }
                }
              ]
          });
        }

        if($('.home #news').size()>0){
          $('.home #news .mobile').slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots:false,
              autoplay: true,
              autoplaySpeed: 3000,
              infinite: true,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    dots:true,
                  }
                }
              ]
          });
        }

        if($('.home #atouts').size()>0){
          $('.home #atouts .list').slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              arrows: true,
              dots:false,
              autoplay: true,
              autoplaySpeed: 3000,
              infinite: true,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    dots:true,
                    arrows:false,
                    adaptiveHeight:true,
                  }
                }
              ]
          });
        }

        if($('.home #testimonies').size()>0){
          $('.home #testimonies .list').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots:true,
              autoplay: true,
              autoplaySpeed: 8000,
              infinite: true
          });
        }

        if($('.home #references').size()>0){
          $('.home #references .list').slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: true,
              dots:false,
              autoplay: true,
              autoplaySpeed: 3000,
              infinite: true,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    adaptiveHeight:true,
                  }
                }
              ]
          });
        }


        $('.animate').each(function(i, obj) {
            if(i > 20){ return false; }
            $(this).delay(200*i).queue(function() {
            $(this).removeClass("animate");
            $(this).dequeue();
        });});

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },

    'single': {
      init: function() {
        $('.last-news .list').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots:false,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  dots:true,
                }
              }
            ]
        });

        $('.animate').each(function(i, obj) {
            if(i > 20){ return false;}
            $(this).delay(200*i).queue(function() {
            $(this).removeClass("animate");
            $(this).dequeue();
        });});

        if($('.bt-like').size() > 0){
          $('.bt-like').click(function(e){
            e.preventDefault();
            var button = $(this);
            if(!button.hasClass('inactive')){
              button.addClass('loading');
              $.ajax({
                url: button.data('url'),
                data: {
                    id: button.data('id')
                },
                success: function(data) {
                  var count = parseInt(button.find('.count').text());
                  button.removeClass('loading');
                  if(data === 'ok'){
                    //console.log(count);
                    button.addClass('active');
                    button.find('.count').text(count+1);
                  }
                  if(data === 'ko'){
                    //console.log(count);
                    button.removeClass('active');
                    button.find('.count').text(count-1);
                  }
                }
              });
            }
          });
        }
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

          $('.single').on('click', '#comments h4', function() {
            $(this).toggleClass('expend');
            $('.comments-content').toggleClass('expend');
          });


      }
    },

    'blog': {
      init: function() {
        if( $('.blog').size() > 0 || $('.category').size() >0 ){

          $('.animate').each(function(i, obj) {
              if(i > 20){ return false;}
              $(this).delay(200*i).queue(function() {
              $(this).removeClass("animate");
              $(this).dequeue();
          });});

            /***************************
            *     RELOAD MORE LIST
            ***************************/
           var load = false;
           var currentPage = $('#news .list .nav').data('paged');
           var maxNumPages = $('#news .list .nav').data('max');
           var postsPerPage = $('#news .list .nav').data('perpage');
           var foundPosts = $('#news .list .nav').data('foundposts');

           if (foundPosts > postsPerPage && maxNumPages > 1) {
               $('#news .more').show();
           }
           if(currentPage + 1 > maxNumPages){ $('#news .more').hide(); }

           $('#news .more a').click(function(e){
               e.preventDefault();

               if (!load && ($('#news .item').size() >= postsPerPage) && ($('#news .item').size() < foundPosts)) {

                   load = true;
                   $('#news .loader').show();
                   $('#news .more').hide();

                   var nextPage = currentPage + 1;

                   if (nextPage <= maxNumPages) {

                       $.ajax({
                           url: $('#news .list .nav').data('url'),
                           data: {
                               paged: nextPage
                           },
                           success: function(data) {
                               if (data !== '') {

                                    currentPage++;
                                    $('#news .list .nav').append(data);
                                    $('.animate').each(function(i, obj) {
                                        if(i > 20){ return false; }
                                        $(this).delay(200*i).queue(function() {
                                        $(this).removeClass("animate");
                                        $(this).dequeue();
                                        var count = parseInt($('.total .count').text());
                                        //console.log(text);
                                        $('.total .count').html(count + 1);
                                    });});

                                   load = false;
                                   $('#news .loader').hide();

                                  if (nextPage === maxNumPages) {
                                      $('#news .more').hide();
                                  }
                                  else {
                                      $('#news .more').show();
                                  }
                               }

                           }
                       });
                   }
               }
           });
       }
      }
    },

    // Tag page
    'tag': {
      init: function() {
        $('.animate').each(function(i, obj) {
            if(i > 20){ return false; }
            $(this).delay(200*i).queue(function() {
            $(this).removeClass("animate");
            $(this).dequeue();
        });});
      }
    },

    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },

    // Mon livre page
    'page_template_default': {
      init: function() {
        if($('.mon-livre #book-review').size()>0){
          $('.mon-livre #book-review .list').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots:true,
              autoplay: true,
              autoplaySpeed: 8000,
              infinite: true,
              adaptiveHeight: true
          });
        }

        if($('.formations #testimonials-training').size()>0){
          $('.formations #testimonials-training .list').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots:true,
              autoplay: true,
              autoplaySpeed: 8000,
              infinite: true
          });
        }
      }
    },


    // Contact page
    'contact': {
      init: function() {
        // JavaScript to be fired on the contact page
        /*function getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        };*/

        if($('#custom-message').length > 0){
          var msg = $('#custom-message').val();
          $('#input_1_8').text(msg.replace(/\\n/g,"\n"));
        }
      }
    },

    // About us page, note the change from about-us to about_us.
    'page_template_template_training': {
      init: function() {
        // JavaScript to be fired on training page
        $('div[class^="card-header"]').on( "click", function() {
          if($(this).hasClass('show')){
            $(this).removeClass('show');
          } else {
            $(this).addClass('show');
          }
        });

        /*$('div[id^="#program-head"]').on( "click", function() {
          console.log('yy');
          if($(this).hasClass('show')){
            $(this).removeClass('show');
          } else {
            $(this).addClass('show');
          }
        });*/

      }
    },

    'mon_espace': {
      init: function() {
        // JavaScript to be fired on the about us page

        if($('.account-nav').size() > 0){
          $('.account-nav a').click(function(e){
            e.preventDefault();
            var part = $(this).attr('href');
            $('.part-content').hide();
            $(part).fadeIn();
          });
        }

        function profilecomplete(){
          if($('.popup-complete').size() > 0){
            $('.popup-complete').fadeIn().delay(10000).fadeOut(); // 10s

            var cpt = 0;
            var complete = 0;
            $('.profileform .form-control').each(function() {
              cpt++;
              if($(this).val() !== ''){ complete++; }
            });
            var percent = Math.round(( complete * 100 ) / cpt);
            //console.log($('.account-header .avatar-default').size());
            if($('.account-header .avatar-default').size() > 0){
              percent = percent - 10;
              $('.popup-complete p').html('Ajoutez une photo de profil !');
            }
            $('.popup-complete .percent').text(percent);
            $('.popup-complete progress').val(percent);
            if(percent === 100){ $('.popup-complete p').html('Félicitations,<br />votre profil est complet !'); }
          }
        }

        profilecomplete();

        if($('.profileform').size() > 0){
          $('.profileform h3').click(function(e){
            e.preventDefault();
            var id = $(this).attr('id');
            $(this).toggleClass('open');
            $('.'+id).toggleClass('open');
          });
          $('.profileform').submit(function(e){
            var form = $(this);
            $('.status').removeClass('success');
            $('.status').removeClass('error');
            $('.status').html('');
            if(form[0].checkValidity() !== false){
              e.preventDefault();
              form.find('.btn').hide();
              form.find('.loader').show();
              $.ajax({
                url: form.attr('action'),
                type: "POST",
                data: form.serialize(),
                success: function(data)
                {
                  if(data === true){
                    form.addClass('was-validated');
                    $('.status').addClass('success');
                    $('.status').html('Vos données ont bien été mises à jour.');
                    profilecomplete();
                  }
                  else{
                    $('.status').addClass('error');
                    $('.status').html('Une erreur est survenue, veuillez ré-éssayer.');
                  }
                  form.find('.btn').show();
                  form.find('.loader').hide();
                }
              });
            }
            else{
              $('.status').addClass('error');
              $('.status').html('Veuillez remplir tous les champs obligatoires.');
            }
          });
        }

        if($('#wpua-file-existing').size() || $('#wpua-add-existing').size() > 0){
          $('.avatar-up a').click(function(e){
            e.preventDefault();
            $('.popup-cgu-avatar').fadeIn();
            $('.popup-cgu-avatar .btn-submit').click(function(e){
              e.preventDefault();
              $('.avatar-up .loading-off').hide();
              $('.avatar-up .loading-on').css('display', 'inline-block');
              $("#wpua-file-existing").trigger('click');
              $("#wpua-add-existing").trigger('click');
              $.ajax({
                url: $('.popup-cgu-avatar').data('action'),
                type: "POST",
                data: { checkacgu : $('input[name=cgu-avatar]:checked').val() },
                success: function(data)
                {
                  $('.popup-cgu-avatar').fadeOut();
                }
              });
            });
            $('.popup-cgu-avatar .backclose').click(function(e){
              e.preventDefault();
              $('.popup-cgu-avatar').fadeOut();
            });
          });
          $("#wpua-file-existing").live('change', function(){
            $('.avatar-up .message').hide();
            var file = this.files[0];
            var imagefile = file.type;
            var imagesize = file.size;
            var match= ["image/jpeg","image/png","image/jpg","image/gif"];
            //console.log('here'+imagesize);
            if(!((imagefile===match[0]) || (imagefile===match[1]) || (imagefile===match[2]) || (imagefile===match[3]))){
              $('.avatar-up .message').html('Format d\'image invalide !');
              $('.avatar-up .message').fadeIn().delay( 2000 ).fadeOut();
            }
            else if(imagesize > 2048000){ //2048KB
              $('.avatar-up .message').html('Poids maximum : 2048KB.');
              $('.avatar-up .message').fadeIn().delay( 2000 ).fadeOut();
            }
            else{
              $('#wpua-upload-existing').trigger('click');
            }
          });
        }

        if($('.avatar-up .updated').size() > 0){
          $('.avatar-up .updated').html('Photo de profil mise à jour !');
          $('.avatar-up .updated').fadeIn().delay( 3000 ).fadeOut();
        }
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
